import { useFragmentsViewCapture } from '@app/modules/fragments/hooks/useFragmentsViewCapture';
import { downloadFile } from '@mi-front/core';
import AudioFileIcon from '@mui/icons-material/AudioFile';
import VideoFileIcon from '@mui/icons-material/VideoFile';
import { Button } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';

interface Props {
  readonly mediaUrl: string;
  readonly mediaType: 'AUDIO' | 'VIDEO';
}

export function ForceDownloadMediaBtn({ mediaUrl, mediaType }: Props) {
  const { $t } = useIntl();
  const { downloadMedia } = useFragmentsViewCapture();

  function handleClick() {
    downloadMedia({ mediaType });
    downloadFile(`${mediaUrl}&response-content-disposition=attachment;`, false);
  }

  return (
    <Button
      color="secondary"
      variant="outlined"
      size="small"
      onClick={handleClick}
      startIcon={mediaType === 'AUDIO' ? <AudioFileIcon /> : <VideoFileIcon />}
    >
      <FormattedMessage
        id="fragments.export.downloadMedia"
        defaultMessage="Descargar {type}"
        values={{
          type:
            mediaType === 'AUDIO'
              ? $t({ id: 'common.audio', defaultMessage: 'audio' })
              : $t({ id: 'common.video', defaultMessage: 'video' }),
        }}
      />
    </Button>
  );
}
